var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7161 0.444458L25.2169 28.4412L13.9832 31.5556L2.78037 28.4456L0.283875 0.444458H27.7161Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0774 26.6585L25.2131 2.73398H14V29.1751L23.0774 26.6585Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00702 13.1192L6.31482 16.5534H14V13.1192H6.00702Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.16818H13.9881H5.38855L5.70073 9.60244H14V6.16818Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6112V22.0381L13.9849 22.0422L10.1602 21.0094L9.91568 18.2704H8.05717H6.46826L6.9494 23.6627L13.9841 25.6156L14 25.6112Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.217 16.5533L17.8183 21.0073L13.9881 22.0411V25.6139L21.0284 23.6627L21.0801 23.0825L21.8871 14.0413L21.9709 13.1191L22.5909 6.16818H13.9881V9.60244H18.8273L18.5148 13.1191H13.9881V16.5533H18.217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.f5c75fa99ec30b61e6b06559ef927d77.svg";
export { ForwardRef as ReactComponent };